import $ from 'jquery'

export function initialise() {
  $('.flipper-text').each(function () {
    const $flipper = $(this)
    const $container = $('div', $flipper)
    const $items = $('span', $container)
    let index = 0
    setInterval(function () {
      index = (index + 1) % $items.length
      $container.css('transform', `translateY(-${index * 1.25}em)`)
    }, 1500)
  })
}
